/** دليل احتياجات الحيوان الأليف (F7-39)، نصوص المتجر (ar). */
export const storefrontNeedsAr = {
  title: 'احتياجات حيواني الأليف',
  metaDescription:
    'اقتراح روتين عناية يومي بحسب نوع حيوانك وعمره واحتياجه في بضعة أسئلة. لا يغني عن الفحص البيطري.',
  lead: 'أجب عن بضعة أسئلة وسنقترح روتين عناية يوميًا لحيوانك الأليف.',
  privacy: 'تبقى إجاباتك في هذا المتصفح فقط ولا تُرسل إلينا.',
  disclaimer: 'هذا الاقتراح لا يغني عن الفحص البيطري.',
  start: 'ابدأ',
  steps: {
    species: 'النوع',
    basics: 'معلومات أساسية',
    areas: 'مجالات الدعم',
    questions: 'الأسئلة',
    result: 'النتيجة',
  },
  progress: 'التقدّم',
  stepOf: 'الخطوة {{n}} من {{total}}',
  speciesQuestion: 'ما نوع حيوانك الأليف؟',
  basicsQuestion: 'لنتعرّف إلى حيوانك',
  age: 'العمر',
  ages: { baby: 'صغير', young: 'يافع', adult: 'بالغ', senior: 'مسن' },
  weight: 'الوزن',
  weights: {
    under_2: 'أقل من 2 كغ',
    '2_5': '2–5 كغ',
    '5_10': '5–10 كغ',
    '10_25': '10–25 كغ',
    over_25: 'أكثر من 25 كغ',
  },
  neutered: 'هل هو معقّم؟',
  neuteredOptions: { yes: 'نعم', no: 'لا', unknown: 'لا أعرف' },
  reproductive: 'هل هي حامل أو مرضع؟',
  reproductiveOptions: { none: 'لا', pregnant: 'حامل', lactating: 'مرضع', unknown: 'لا أعرف' },
  areasQuestion: 'في أي المجالات تبحث عن دعم؟',
  multipleHint: 'يمكنك اختيار أكثر من مجال.',
  noAreas: 'لم تُحدَّد مجالات دعم لهذا النوع بعد.',
  browseSpecies: 'تصفّح منتجات {{species}}',
  back: 'رجوع',
  next: 'متابعة',
  seeResult: 'عرض النتيجة',
  restart: 'البدء من جديد',
  change: 'تغيير',
  answerRequired: 'اختر إجابة للمتابعة.',
  resultTitle: 'الروتين المقترح لحيوانك',
  resultLead: 'نقترح {{count}} منتجات؛ يمكنك إزالة ما لا تريده.',
  why: 'سبب الاقتراح',
  usage: 'طريقة الاستخدام',
  include: 'ضمن الروتين',
  includeLabel: '{{name}} ضمن الروتين',
  alternativeFor: 'المنتج المقترح غير متوفر، لذا يظهر هذا المنتج بديلًا.',
  option: 'الخيار: {{name}}',
  otherOptions: 'خيارات أخرى في صفحة المنتج',
  total: 'الإجمالي',
  totalNote: 'تم اختيار {{count}} منتجات. يُحسب الشحن والحملات في السلة.',
  addAll: 'أضف الكل إلى السلة',
  adding: 'جارٍ الإضافة…',
  added: 'أُضيف {{count}} منتجات إلى السلة.',
  goCart: 'الذهاب إلى السلة',
  addFailed: 'تعذّرت إضافة {{name}}: {{error}}',
  nothingSelected: 'اختر منتجًا واحدًا على الأقل لإضافته إلى السلة.',
  empty: 'لم نجد منتجات تناسب إجاباتك.',
  emptyLead: 'يمكنك اختيار مجال دعم آخر أو تصفّح كل المنتجات.',
  browseAll: 'تصفّح كل المنتجات',
  emergencyTitle: 'يرجى مراجعة طبيب بيطري أولًا',
  emergencyText:
    'قد تتطلب الحالة التي اخترتها رعاية عاجلة. لا نقترح منتجات في هذه الحالة؛ يرجى مراجعة طبيب بيطري دون تأخير.',
  emergencyLinks: 'صفحات قد تساعدك',
  emergencyBack: 'تغيير إجابتي',
  bundle: 'حملة سارية على هذا الروتين',
  answersTitle: 'إجاباتك',
  summary: {
    title: 'ملخّص الروتين',
    empty: 'تظهر الاقتراحات هنا كلما أجبت عن الأسئلة.',
    show: 'عرض الروتين ({{count}})',
    pending: 'الأسئلة المتبقية: {{count}}',
  },
  chat: {
    greeting: 'مرحبًا! لنُعدّ روتين عناية لحيوانك بأسئلة قصيرة.',
    log: 'الأسئلة وإجاباتك',
    question: 'سؤال',
    answer: 'إجابتك',
    edit: 'تغيير الإجابة',
    resultIntro: 'الروتين الذي نقترحه بناءً على إجاباتك:',
    fixed: 'هذه الأسئلة ثابتة وتُجاب بالقواعد نفسها لكل زائر.',
  },
  savePet: {
    title: 'احفظ حيواني',
    lead: 'احفظ المعلومات الأساسية في حسابك حتى لا تُدخلها مرة أخرى. لا تُحفظ إجابات الأسئلة الصحية.',
    name: 'اسم حيوانك',
    consent:
      'أوافق صراحةً على حفظ نوع حيواني وعمره ونطاق وزنه ومعلومات التعقيم والحمل/الإرضاع ومجالات الدعم التي اخترتها في حسابي واستخدامها لعرض الاقتراحات لي. يمكنني حذف هذا السجل في أي وقت من صفحة حسابي.',
    save: 'احفظ حيواني',
    saved: 'تم حفظ حيوانك.',
    login: 'سجّل الدخول للحفظ',
  },
  pets: {
    title: 'حيواناتي المحفوظة',
    lead: 'المعلومات الأساسية التي حفظتها بموافقتك الصريحة في دليل الاحتياجات.',
    use: 'ابدأ لـ {{name}}',
    unnamed: 'حيواني ({{species}})',
    delete: 'حذف',
    deleteLabel: 'حذف سجل {{name}}',
    deleted: 'تم حذف السجل.',
    empty: 'لا توجد حيوانات محفوظة.',
    open: 'افتح دليل الاحتياجات',
  },
  seed: {
    reason: 'لمجال الدعم «{{area}}» الذي اخترته.',
    emergencyQuestion: 'هل يعاني حيوانك الآن من أيٍّ مما يلي؟',
    emergencyHelp: 'إن كان كذلك فلا نقترح منتجات؛ يرجى مراجعة طبيب بيطري أولًا.',
    emergencyNone: 'لا شيء مما سبق',
    emergency: {
      breathing: 'يجد صعوبة في التنفس',
      bleeding: 'نزيف لا يتوقف',
      poison: 'ربما أكل أو لعق شيئًا سامًا',
      seizure: 'يعاني من نوبة تشنج',
      collapse: 'انهار أو لا يستطيع الوقوف',
      not_eating: 'لا يأكل ولا يشرب إطلاقًا منذ أكثر من يوم',
    },
    pregnancyNote: 'يذكر نص تحذير المنتج الحمل أو الإرضاع.',
    intro: 'اختر نوع حيوانك وعمره والمجالات التي تبحث فيها عن دعم؛ وسنقترح روتين عناية يوميًا مناسبًا.',
    emergencyText:
      'قد تتطلب الحالة التي اخترتها رعاية عاجلة. لا نقترح منتجات في هذه الحالة؛ يرجى مراجعة طبيب بيطري دون تأخير.',
  },
};
